import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_Footer = _resolveComponent("Footer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Header), (_openBlock(), _createBlock(_component_router_view, {
    key: $options.routePath
  })), _createVNode(_component_Footer)], 64);
}